/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import {Divider, useMediaQuery, useTheme } from "@mui/material";
import React, {  useState } from "react";
import { TInfoAccount } from "../../account/utils/types";
import AccountAnswerInfo from "../../account/components/AccountAnswerInfo";
import AccountArenaInfo from "../../account/components/AccountArenaInfo";
import AchievementsTab from "../../account/components/AccountAchivementTab";
import InfoAccountDetail from "../../account/components/InfoAccountDetail";
import ModalGiftDiamond from "../../account/components/ModalGiftDiamond";
import AccountPreview from "./AccountPreview";
import GroupTab from "../../account/components/GroupTab";
import { TTheme } from "../../../utils/configs/setupTheme";

type TProps = {
  infoAccount: TInfoAccount;
  openModalGiftDiamond: boolean;
  handleOpenModalGiftDiamond: () => void;
  handleCloseModalGiftDiamond: () => void;
  isFriendView?: boolean;
};
const DetailAccountView = (props: TProps) => {
  const [tab, setTab] = useState("info");
  const matches900 = useMediaQuery("(min-width:900px)");
  const theme: TTheme = useTheme();
  const handleChangeTab = (tabStr: string) => {
    setTab(tabStr);
  };
  const {
    infoAccount,
    openModalGiftDiamond,
    handleOpenModalGiftDiamond,
    handleCloseModalGiftDiamond,
    isFriendView
  } = props;
  if (infoAccount?.created_at === 0) return null;
  return (
    <div className={`bg-white rounded-lg pb-3 overflow-auto ${(isFriendView && !matches900) ? "w-[calc(100vw-320px)]": "w-full"}`}>
      <AccountPreview
        infoAccount={infoAccount}
        handleOpenModalGiftDiamond={handleOpenModalGiftDiamond}
        // handleCloseModalGiftDiamond={handleCloseModalGiftDiamond}
        isFriendPreview
      />
      <Divider sx={{ color: theme.palette.primary.gray }} />
      <div className="px-4 py-2">
        <GroupTab
          tab={tab}
          handleChangeTab={handleChangeTab}
          extraAchievement={`(${infoAccount?.num_of_achievement_member}/${infoAccount?.total_achievement})`}
        />
        <div className="mt-6">
          {tab === "info" && <InfoAccountDetail infoAccount={infoAccount} />}
          {tab === "achievements" && (
            <AchievementsTab memberHid={infoAccount?.pub_id} />
          )}
          {tab === "compat" && (
            <AccountArenaInfo memberHid={infoAccount?.pub_id} />
          )}
          {tab === "answer" && (
            <AccountAnswerInfo memberHid={infoAccount?.pub_id} />
          )}
        </div>
        {openModalGiftDiamond && (
          <ModalGiftDiamond
            open={openModalGiftDiamond}
            handleClose={() => handleCloseModalGiftDiamond()}
          />
        )}
      </div>
    </div>
  );
};
export default DetailAccountView;
